// extracted by mini-css-extract-plugin
module.exports = {"shadow":"DataDetails_shadow__2iY8K","dataDetailsWrapper":"DataDetails_dataDetailsWrapper__35FQj"};